export default [
  { title: 'About Omnifood', to: '#!' },
  { title: 'For Business', to: '#!' },
  { title: 'Cooking partners', to: '#!' },
  { title: 'Careers', to: '#!' },
];
